import { EntityType } from "DealerApp/lib/scalars"
import React from "react"

export type OrganizationEntity = {
  type: EntityType
  id: string
}

export const DEFAULT_ENTITY: OrganizationEntity = {
  id: "",
  type: "CUSTOMER",
}

const EntityContext = React.createContext<OrganizationEntity>(DEFAULT_ENTITY)
export const EntityContextProvider = EntityContext.Provider
export default EntityContext
